import Repository from "./repository.js";

class AdminRepository {
  // Repository For Contact us Form

  async contactus(payload) {
    const response = await Repository.post("/auth/contact_us", payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error("Error in contactus API:", err);
        throw err; // Throwing error to handle it in the hook 
      });
    return response;
  }

  //tracking visitor counts
  async trackVisitor() {
    try {
      const response = await Repository.post("/auth/track-visiters");
      return response;
    } catch (err) {
      console.log(err);
    }
  }

  // getting visitor counts
  async getVisitorCounts() {
    try {
      const response = await Repository.get("/auth/visitor-count");
      return response;
    } catch (err) {
      console.log(err);
    }
  }
}

export default new AdminRepository();
